






















































































import { defineComponent, ref, watch } from '@vue/composition-api';
import { useVoiceClass } from '../composables/useVoiceClass';

import VoiceClassCreateForm from '../components/VoiceClassCreateForm.vue';
import VoiceClassEditForm from '../components/VoiceClassEditForm.vue';

export default defineComponent({
  name: 'VoiceClass',
  components: {
    VoiceClassCreateForm,
    VoiceClassEditForm,
  },
  setup() {
    const {voiceClasses, total, loading, fetchVoiceClasses} = useVoiceClass();
    const dialog = ref(false);
    const editDialog = ref(false);
    const selectedVoiceClass = ref<any>(null);
    const options = ref<any>({
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    });

    const headers = [
      {text: 'Name', value: 'name'},
      {text: 'Description', value: 'description'},
      {text: 'Instructor', value: 'instructor'},
      {text: 'Image', value: 'thumbnail'},
      {text: 'Video', value: 'video'},
      {text: 'Created At', value: 'created_at'},
      {text: 'Actions', value: 'actions', sortable: false},
    ];

    const loadItems = async () => {
      await fetchVoiceClasses({
        skip: (options.value.page - 1) * options.value.itemsPerPage,
        take: options.value.itemsPerPage,
        sortBy: options.value.sortBy[0],
        sortDesc: options.value.sortDesc[0],
      });
    };

    watch(options, async () => {
      await loadItems();
    });

    const handleSubmit = async () => {
      dialog.value = false;
      editDialog.value = false;
      await loadItems();
    };

    const handleEdit = async (voiceClass: any) => {
      selectedVoiceClass.value = voiceClass;
      editDialog.value = true;
    };

    return {
      voiceClasses,
      total,
      loading,
      options,
      headers,
      dialog,
      editDialog,
      selectedVoiceClass,
      handleSubmit,
      handleEdit,
    };
  },
});
